import { useState } from 'react';

export default function useForceRerender() {
    const [tick, setTick] = useState(0);
    return [tick, () => setTick((tick) => tick + 1)];
}
